import { Page, BasePlanVO } from "@/libs/model/common/index";
/**新建赛事 */
export class TrainingClassVO extends BasePlanVO {
  constructor() {
    super();
    this.times = "";
    this.disciplineList = [];
    this.trainingClassId = "";
    this.trainingClassType = "";
  }
}
export class ClassPageListVO extends Page {
  constructor() {
    super();
    this.approveStatus = "";
    this.name = "";
    this.province = "";
    this.type = "";
    this.year = "";
  }
}
export class TrainingClassId {
  constructor() {
    this.trainingClassId = "";
  }
}
export class BatchTrainingClassId {
  constructor() {
    this.trainingClassId = [];
  }
}
